export default {
  large: 'body-16',
  medium: 'body-14',
  small: 'caption-10',
}
